<template>
  <!-- 密码验证界面 -->
  <div class="password-container" v-if="!isAuthenticated">
    <div class="password-dialog">
      <div class="password-header">
        <h2>莲蓉园商贸管理系统</h2>
        <p>请输入密码访问</p>
      </div>
      <div class="password-input">
        <el-input
          v-model="password"
          type="password"
          placeholder="请输入密码"
          @keyup.enter="checkPassword"
          :class="{ 'error': passwordError }"
        ></el-input>
        <p class="error-message" v-if="passwordError">{{ passwordError }}</p>
      </div>
      <div class="password-actions">
        <el-button type="primary" @click="checkPassword" :loading="loading">进入系统</el-button>
      </div>
    </div>
  </div>

  <!-- 主界面 -->
  <div class="home-container" v-else>
    <!-- 顶部标题 -->
    <div class="header">
      <h1 class="title">莲蓉园商贸有限公司</h1>
      <p class="subtitle">欢迎使用销售订单管理系统</p>
      <div class="logout-btn">
        <el-button size="small" @click="logout">退出系统</el-button>
      </div>
    </div>

    <!-- 功能卡片区域 -->
    <div class="feature-cards">
      <!-- 销售开单卡片 -->
      <el-card class="feature-card" shadow="hover" @click="navigateTo('/orders/create')">
        <div class="card-content">
          <div class="card-icon" style="background-color: #409EFF;">
            <i class="el-icon-document"></i>
          </div>
          <div class="card-info">
            <h3>销售开单</h3>
            <p>创建新的销售订单</p>
          </div>
        </div>
      </el-card>

      <!-- 统计（原统计卡片保留，仅删除下方数据统计栏） -->
      <el-card class="feature-card" shadow="hover" @click="navigateTo('/statistics')">
        <div class="card-content">
          <div class="card-icon" style="background-color: #909399;">
            <i class="el-icon-data-analysis"></i>
          </div>
          <div class="card-info">
            <h3>数据统计</h3>
            <p>查看销售统计数据</p>
          </div>
        </div>
      </el-card>

      <!-- 订单管理卡片 -->
      <el-card class="feature-card" shadow="hover" @click="navigateTo('/orders')">
        <div class="card-content">
          <div class="card-icon" style="background-color: #67C23A;">
            <i class="el-icon-tickets"></i>
          </div>
          <div class="card-info">
            <h3>订单管理</h3>
            <p>查看和管理所有订单</p>
          </div>
        </div>
      </el-card>

      <!-- 客户管理卡片 -->
      <el-card class="feature-card" shadow="hover" @click="navigateTo('/customers')">
        <div class="card-content">
          <div class="card-icon" style="background-color: #E6A23C;">
            <i class="el-icon-user"></i>
          </div>
          <div class="card-info">
            <h3>客户管理</h3>
            <p>管理客户信息</p>
          </div>
        </div>
      </el-card>

      <!-- 商品管理卡片 -->
      <el-card class="feature-card" shadow="hover" @click="navigateTo('/merchandises')">
        <div class="card-content">
          <div class="card-icon" style="background-color: #F56C6C;">
            <i class="el-icon-goods"></i>
          </div>
          <div class="card-info">
            <h3>商品管理</h3>
            <p>管理商品信息</p>
          </div>
        </div>
      </el-card>
    </div>

  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {
      isAuthenticated: false,
      password: '',
      passwordError: '',
      loading: false,
      // 设置密码，这里使用简单的固定密码，您可以根据需要修改
      correctPassword: '18100885307' // 请修改为您想要的密码
    }
  },
  mounted() {
    // 检查本地存储中是否有认证信息
    const auth = localStorage.getItem('systemAuthenticated');
    if (auth === 'true') {
      this.isAuthenticated = true;
    }
  },
  methods: {
    checkPassword() {
      this.loading = true;
      this.passwordError = '';
      
      // 模拟验证过程
      setTimeout(() => {
        if (this.password === this.correctPassword) {
          this.isAuthenticated = true;
          // 将认证状态存储到本地存储，刷新页面后仍然保持登录状态
          localStorage.setItem('systemAuthenticated', 'true');
        } else {
          this.passwordError = '密码错误，请重新输入';
        }
        this.loading = false;
      }, 500);
    },
    
    logout() {
      this.isAuthenticated = false;
      this.password = '';
      localStorage.removeItem('systemAuthenticated');
    },
    
    navigateTo(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style scoped>
.home-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.header {
  text-align: center;
  margin-bottom: 40px;
  position: relative;
}

.title {
  font-size: 32px;
  color: #303133;
  margin-bottom: 10px;
}

.subtitle {
  font-size: 16px;
  color: #606266;
}

.logout-btn {
  position: absolute;
  top: 0;
  right: 0;
}

.feature-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.feature-card {
  cursor: pointer;
  transition: all 0.3s ease;
  height: 120px;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1) !important;
}

.card-content {
  display: flex;
  align-items: center;
  height: 100%;
}

.card-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.card-icon i {
  font-size: 24px;
  color: white;
}

.card-info h3 {
  margin: 0 0 8px 0;
  font-size: 18px;
  color: #303133;
}

.card-info p {
  margin: 0;
  color: #909399;
  font-size: 14px;
}

/* 密码验证界面样式 */
.password-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.password-dialog {
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  width: 400px;
  max-width: 90%;
  text-align: center;
}

.password-header {
  margin-bottom: 30px;
}

.password-header h2 {
  color: #303133;
  margin-bottom: 10px;
}

.password-header p {
  color: #606266;
  font-size: 14px;
}

.password-input {
  margin-bottom: 20px;
}

.error-message {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 5px;
  text-align: left;
}

:deep(.el-input.error .el-input__inner) {
  border-color: #f56c6c;
}

.password-actions {
  margin-top: 20px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .feature-cards {
    grid-template-columns: 1fr;
  }
  
  .password-dialog {
    padding: 30px 20px;
  }
  
  .logout-btn {
    position: static;
    margin-top: 10px;
  }
}
</style>